/* Blair TLV product-video fix — shipped as its own asset to bypass global.js's
   sticky ?v= asset cache (Admin-API edits to global.js don't reliably bump ?v=,
   so corrected logic never reached visitors). Self-contained + idempotent.

   Fixes on the product media gallery:
   - Dawn wraps each video in <deferred-media>, un-hidden only at min-width:750px,
     so on mobile the autoplay <video class="product__media-video"> is display:none.
   - The <modal-opener> still paints the poster image, and the raw <video> renders
     at its natural (tall) size -> poster + oversized video "stacked".
   Why a naive height:100% fails: the video's % height resolves against
   <deferred-media>, whose own height is `auto` (it comes from top/bottom:0, not an
   explicit height), so per spec the % falls back to the video's natural height
   (~2x). Fix: measure the media container's pixel height and set it explicitly on
   the wrapper + video, make the container the positioning context with overflow
   hidden, fit the video (object-fit:cover), and hide the duplicate poster.
   Plus: autoplay muted when >=25% in view, pause when out (battery). Re-applied on
   load / resize / section load so the pixel height tracks the layout. */
(function () {
  function fit(v) {
    var c = v.closest('.product-media-container');
    if (!c) return;
    var dm = v.closest('deferred-media');
    c.style.setProperty('position', 'relative', 'important');
    c.style.setProperty('overflow', 'hidden', 'important');
    // hide the duplicate poster first (keeps layout space -> container height holds)
    var pm = c.querySelector('.product__modal-opener .product__media');
    if (pm) pm.style.setProperty('visibility', 'hidden', 'important');
    // Compute the target pixel height from the container WIDTH and Dawn's --ratio
    // (set on the container as media.aspect_ratio). This is reliable immediately —
    // unlike clientHeight, it doesn't wait for the lazy-loaded poster image, which
    // on an off-screen slider slide is 0 (then % height fell back to the video's
    // natural ~2x size). Prefer a real clientHeight when we have one.
    var ratio = parseFloat(getComputedStyle(c).getPropertyValue('--ratio')) || 0;
    var W = c.clientWidth;
    var H = (ratio > 0 && W > 0) ? Math.round(W / ratio) : c.clientHeight;
    if (!(H > 0)) H = c.clientHeight;
    if (dm) {
      dm.style.setProperty('display', 'block', 'important');
      dm.style.setProperty('position', 'absolute', 'important');
      dm.style.setProperty('top', '0', 'important');
      dm.style.setProperty('left', '0', 'important');
      dm.style.setProperty('width', '100%', 'important');
      if (H > 0) dm.style.setProperty('height', H + 'px', 'important');
      dm.style.setProperty('z-index', '1', 'important');
    }
    v.style.setProperty('display', 'block', 'important');
    v.style.setProperty('position', 'absolute', 'important');
    v.style.setProperty('top', '0', 'important');
    v.style.setProperty('left', '0', 'important');
    v.style.setProperty('width', '100%', 'important');
    v.style.setProperty('height', (H > 0 ? H + 'px' : '100%'), 'important');
    v.style.setProperty('object-fit', 'cover', 'important');
  }
  var io = null;
  function observer() {
    if (io || !('IntersectionObserver' in window)) return io;
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting) { v.muted = true; var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        else { try { v.pause(); } catch (err) {} }
      });
    }, { threshold: 0.25 });
    return io;
  }
  function setup() {
    var vids = document.querySelectorAll('.product__media-list video.product__media-video');
    if (!vids.length) return;
    var ob = observer();
    vids.forEach(function (v) {
      fit(v);
      if (v.dataset.btVfix) return;
      v.dataset.btVfix = '1';
      v.muted = true;
      // re-fit once the video knows its real dimensions / once images settle
      v.addEventListener('loadedmetadata', function () { fit(v); });
      v.addEventListener('loadeddata', function () { fit(v); });
      if (ob) ob.observe(v);
      else { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
      // re-fit when its slider slide scrolls into view (poster may load late)
      var list = v.closest('.product__media-list');
      if (list && !list.dataset.btVfixScroll) {
        list.dataset.btVfixScroll = '1';
        var st;
        list.addEventListener('scroll', function () { clearTimeout(st); st = setTimeout(run, 150); }, { passive: true });
      }
    });
  }
  function run() { setup(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  window.addEventListener('load', run);
  document.addEventListener('shopify:section:load', run);
  var rt;
  window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(run, 200); });
  // a couple of delayed passes to catch late layout (poster image load, fonts)
  setTimeout(run, 600);
  setTimeout(run, 1800);
})();
